import * as React from 'react';
import { ActivityIndicator } from '@atomic/atm.activity-indicator';
import { LoadingCenteredStyled } from './loading.component.style';
export const LoadingCentered = () => (React.createElement(LoadingCenteredStyled, null,
    React.createElement(ActivityIndicator, { type: 'spinner' })));
